/**
 * lucide-react v0.274.0 - ISC
 */

import createLucideIcon from '../createLucideIcon.js';

const Loader2 = createLucideIcon("Loader2", [
  ["path", { d: "M21 12a9 9 0 1 1-6.219-8.56", key: "13zald" }]
]);

export { Loader2 as default };
//# sourceMappingURL=loader-2.js.map
